import { generateClient } from "aws-amplify/api";
import { pathBuilder } from "../../Utils";

const client = generateClient();

export async function requestListBanner(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_LIST_BANNER" });

    const res = await client.graphql({
      query: bannersByDeviceUpdatedAt,
      variables: {
        device: "WEB",
        sortDirection: "DESC",
      },
    });

    let { items, nextToken } = res.data.bannersByDeviceUpdatedAt;

    const currentTimestamp = new Date();
    items = items.filter((item) => {
      if (!item?.expiredAt) return true;
      const expiredTimestamp = new Date(item.expiredAt);
      if (isNaN(expiredTimestamp.getTime())) return true;
      return currentTimestamp <= expiredTimestamp;
    });

    items = items.map((item) => {
      let url = "#";
      if (item.target?.type) {
        switch (item.target.type) {
          case "URL":
            url = item.target.id;
            break;
          case "MENU":
            let params = {};
            if (item.target.params) {
              try {
                params = JSON.parse(item.target.params);
              } catch (error) {
                // Cannot parse params
              }
            }
            url = pathBuilder(item.target.id, params.id);
            break;
          default:
            break;
        }
      }
      return {
        ...item,
        url,
      };
    });

    dispatch({
      type: "LIST_BANNER_SUCCESS",
      payload: { items, nextToken },
    });
  } catch (error) {
    dispatch({ type: "LIST_BANNER_ERROR", payload: { error } });
  }
}

const bannersByDeviceUpdatedAt = /* GraphQL */ `
  query BannersByDeviceUpdatedAt(
    $device: BannerDeviceType
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBannerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bannersByDeviceUpdatedAt(
      device: $device
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        subtitle
        imageUrl
        target {
          id
          type
          params
        }
        device
        expiredAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
